import {
  TAssetTreeNode,
} from '@/api/asset.ts';
import {
  TFlattenedAssetTreeNode,
} from '@/types/asset-tree.ts';

export type TTFlattenedAssetTreeNode = TAssetTreeNode & {
  displayNameWithPath: string,
  path: string[],
};

export function flattenAssetTreeAndEnrichWithPath(assetTree: TAssetTreeNode[], assetPath: string[] = [], minChildrenLength: number = 0): TTFlattenedAssetTreeNode[] {
  let assetFilterList: TTFlattenedAssetTreeNode[] = [];

  assetTree.forEach((item) => {
    if (!item.children) {
      return;
    }
    if (assetTree.length > minChildrenLength) {
      assetFilterList.push({
        ...item,
        displayNameWithPath: [
          item.displayName,
          ...assetPath,
        ].join(' > '),
        path: [
          item.displayName,
          ...assetPath,
        ],
      });
      assetFilterList = [
        ...assetFilterList,
        ...flattenAssetTreeAndEnrichWithPath(item.children, [
          item.displayName,
          ...assetPath,
        ]),
      ];
    } else {
      assetFilterList = [
        ...assetFilterList,
        ...flattenAssetTreeAndEnrichWithPath(item.children, assetPath),
      ];
    }
  });

  return assetFilterList;
}

/**
 * Frontend counterpart of the `excludeOfflineTypes` query parameter of the asset tree
 * endpoint: removes offline assets together with all of their descendants.
 */
export function excludeOfflineAssets(assetTree: TAssetTreeNode[]): TAssetTreeNode[] {
  return assetTree
    .filter((assetNode) => !assetNode.isOffline)
    .map((assetNode) => {
      if (!assetNode.children) {
        return assetNode;
      }
      return {
        ...assetNode,
        children: excludeOfflineAssets(assetNode.children),
      };
    });
}

export function flattenAssetTree(assetTree: TAssetTreeNode[], path: TFlattenedAssetTreeNode[] = []): TFlattenedAssetTreeNode[] {
  const treeNodeList: TFlattenedAssetTreeNode[] = [];
  const currentPath: TFlattenedAssetTreeNode[] = [
    ...path,
  ];

  assetTree.forEach((node) => {
    const parent = {
      ...node,
      path: currentPath,
    };
    treeNodeList.push(parent);

    if (node.children) {
      treeNodeList.push(
        ...flattenAssetTree(node.children, [
          parent,
          ...currentPath,
        ]),
      );
    }
  });

  return treeNodeList;
}
